import React, { Component } from "react";

const HeaderHOC = (WrappedHeader) => {
  return class HeaderHOC extends Component {
    constructor(props) {
      super(props);
      this.state = {
        screenWidth: null,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
    }
    componentWillMount() {
      this.updateDimensions();
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
    }
    updateDimensions() {
      this.setState({
        screenWidth: document.getElementsByTagName("body")[0].clientWidth,
      });
    }

    render() {
      // if((!window.location.pathname.match('/projetos/')) && !window.location.pathname.match('/videos/') && !window.location.pathname.match('/parceiros/'))
      return (
        <WrappedHeader {...this.props} screenWidth={this.state.screenWidth} />
      );
      // else
      //     return(
      //         <WrappedHeader colSize={true} background={{backgroundColor: 'white'}} screenWidth={this.state.screenWidth} logoOrder='order-first' classOver='invert' {...this.props}/>
      //     )
    }
  };
};

export default HeaderHOC;



// WEBPACK FOOTER //
// ./src/hoc/HeaderHOC.js